import React, { useContext } from 'react';

// HELPERS
import { RecordContext } from 'helpers/getRecordData';

// GLOBAL PARTS
import Card from 'parts/card/Card';

// LOCAL VARIABLES
import { TRACKING_TYPES } from '../../options';

// LOCAL COMPONENTS
import VehicleManagementItem from './VehicleManagement/VehicleManagementItem';

// MAIN COMPONENT
const VehicleManagement = ({ inventoryId }) => {
  
  // CONTEXT
  const {
    record: { aryTrackCode, aryTrackCodeStatusHistory, date_created, stock_num, make, model, vehicle_year } = {},
    refetchRecord
  } = useContext(RecordContext) || {};

  // RENDER
  return (
    <Card
      title="Vehicle Management"
      body={TRACKING_TYPES.map(trackType => {
        return (
          <VehicleManagementItem
            key={trackType.label}
            typeInfo={trackType}
            status={aryTrackCode?.filter(({ tracking_type_id }) => tracking_type_id === trackType.id)}
            history={aryTrackCodeStatusHistory?.filter(({ tracking_type }) => tracking_type === trackType.key)}
            inventoryId={inventoryId}
            createdAt={date_created}
            refetchRecord={refetchRecord}
            downloadFile={`${stock_num}_${vehicle_year}_${make}_${model}`}
          />
        );
      })}
    />
  );
};

// EXPORT
export default VehicleManagement;
